import React from "react";

const PersianLogoType = (props) => {
  const { fill, fontSize, width, height, transform, viewBox } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "180"}
      height={height || "75"}
      viewBox={viewBox ? viewBox : `0 0 180 ${height}`}
      {...props}
    >
      <text
        fill={fill}
        fontFamily="LalezarRegular"
        fontSize={fontSize}
        transform={
          transform ? transform : `translate(${width} ${height / 1.6})`
        }
      >
        <tspan x="25" y="0">
          لینگوتاک
        </tspan>
      </text>
    </svg>
  );
};

export default PersianLogoType;
